import { render, staticRenderFns } from "./examPoint.vue?vue&type=template&id=74522970"
import script from "./examPoint.vue?vue&type=script&lang=js"
export * from "./examPoint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports